export const IS_LOGGED_IN = 'ysIsLoggedIn';
export const USER_COOKIE = 'ysSessionUser';